// extracted by mini-css-extract-plugin
module.exports = {"loader":"ActionLoader_loader__9NQAe","spin":"ActionLoader_spin__XrjZR"};